import { ProductTypeType } from "types/Product";

export const getProductSKUVariationList = (productTypes: ProductTypeType[]) => {
  const productSKUVariationList: string[] = [];
  productTypes.forEach((productType) => {
    productSKUVariationList.push(productType.value);
  });
  return productSKUVariationList;
};
